var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Dropzone from 'react-dropzone';
import { FormControl, InputLabel, Input, FormHelperText } from '@material-ui/core';
import Autocomplete from './Autocomplete';
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
export var renderTextField = function (_a) {
    var input = _a.input, label = _a.label, _b = _a.meta, touched = _b.touched, error = _b.error, custom = __rest(_a, ["input", "label", "meta"]);
    return (React.createElement(TextField, __assign({ helperText: touched && error, label: label, error: Boolean(touched && error) }, input, custom)));
};
var renderRichTextEditor = /** @class */ (function (_super) {
    __extends(renderRichTextEditor, _super);
    function renderRichTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.onEditorChange = function (e) { return _this.setState({ editorState: e }); };
        _this.onEditorBlur = function () {
            var content = _this.state.editorState.getCurrentContent();
            var html = stateToHTML(content);
            _this.props.input.onChange(html);
        };
        var blocksFromHTML = props.input.value ? convertFromHTML(props.input.value) : null;
        var editorState = blocksFromHTML && blocksFromHTML.contentBlocks
            ? ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
            : null;
        _this.state = {
            editorState: editorState ? EditorState.createWithContent(editorState) : EditorState.createEmpty(),
        };
        return _this;
    }
    renderRichTextEditor.prototype.render = function () {
        return (React.createElement(Editor, { placeholder: "Description", editorState: this.state.editorState, onEditorStateChange: this.onEditorChange, onBlur: this.onEditorBlur }));
    };
    return renderRichTextEditor;
}(React.PureComponent));
export { renderRichTextEditor };
export var renderAutocomplete = function (_a) {
    var input = _a.input, label = _a.label, suggestions = _a.suggestions, _b = _a.meta, touched = _b.touched, error = _b.error, custom = __rest(_a, ["input", "label", "suggestions", "meta"]);
    return (React.createElement("div", null,
        React.createElement(Autocomplete, { input: input, placeholder: label, error: Boolean(error && touched), suggestions: suggestions }),
        Boolean(touched && error) && React.createElement(FormHelperText, { style: { color: 'red' } }, error)));
};
export var renderAutocompleteWithLabel = function (_a) {
    var input = _a.input, label = _a.label, disabled = _a.disabled, suggestions = _a.suggestions, _b = _a.meta, touched = _b.touched, error = _b.error, custom = __rest(_a, ["input", "label", "disabled", "suggestions", "meta"]);
    return (React.createElement("div", null,
        label && (React.createElement(InputLabel, { disabled: disabled, style: { fontSize: '13px' }, htmlFor: input.name }, label)),
        React.createElement(Autocomplete, { placeholder: label, input: input, disabled: disabled, error: Boolean(error && touched), suggestions: suggestions }),
        Boolean(touched && error) && React.createElement(FormHelperText, { style: { color: 'red' } }, error)));
};
export var renderSelectWithLabel = function (_a) {
    var input = _a.input, label = _a.label, _b = _a.meta, touched = _b.touched, error = _b.error, custom = __rest(_a, ["input", "label", "meta"]);
    return (React.createElement(FormControl, { style: { fontSize: '13px' }, error: Boolean(touched && error), className: 'w-full' },
        label && React.createElement(InputLabel, { htmlFor: input.name }, label),
        React.createElement(Select, __assign({}, input, { input: React.createElement(Input, { id: (input.name || input.id || '').replace(/\s{1,}/g, '-'), name: input.name }), label: label }, custom, { MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
            } })),
        Boolean(touched && error) && React.createElement(FormHelperText, null, error)));
};
export var renderSelect = function (_a) {
    var input = _a.input, label = _a.label, _b = _a.meta, touched = _b.touched, error = _b.error, custom = __rest(_a, ["input", "label", "meta"]);
    return (React.createElement(FormControl, { error: Boolean(touched && error), className: input.className },
        label && React.createElement(InputLabel, { htmlFor: input.name }, label),
        React.createElement(Select, __assign({}, input, { input: React.createElement(Input, { id: (input.name || input.id || '').replace(/\s{1,}/g, '-'), name: input.name, style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                } }), label: label }, custom, { MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                height: '50vh',
                style: {
                    maxHeight: '50vh',
                    display: 'flex',
                    justifyContent: 'space-between',
                },
            } })),
        Boolean(touched && error) && React.createElement(FormHelperText, null, error)));
};
export var renderDropdownList = function (_a) {
    var input = _a.input, _b = _a.meta, touched = _b.touched, error = _b.error, rest = __rest(_a, ["input", "meta"]);
    return (React.createElement("div", { className: "input-wrapper" },
        React.createElement(Select, __assign({}, input, rest)),
        touched && error && React.createElement("span", { className: "input-error" }, error)));
};
export var renderDropzoneInput = function (_a) {
    var id = _a.id, input = _a.input, meta = _a.meta, className = _a.className, dropzone = _a.dropzone, label = _a.label;
    return (React.createElement("div", null,
        React.createElement(Dropzone, __assign({ id: id, name: name, className: className }, dropzone, { onDrop: function (filesToUpload, e) {
                input.onChange(filesToUpload);
                if (dropzone && dropzone.onDrop) {
                    dropzone.onDrop(filesToUpload);
                }
            } }),
            React.createElement("div", null, label)),
        meta.touched && meta.error && React.createElement("span", { className: "error" }, meta.error)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/formElements.tsx
// module id = 770
// module chunks = 81